import { useIsLeftNavForcedCollapsedAtCurrentWidth } from '@ms/yammer-web-core-ui/dist/components/AppLayout';

import { useIsLeftNavCollapsed } from './leftNavCollapseStore';
import { useIsLeftNavCollapseEnabled } from './useIsLeftNavCollapseEnabled';

export const useIsLeftNavCollapsedActive = (): boolean => {
  const isLeftNavCollapseEnabled = useIsLeftNavCollapseEnabled();
  const isLeftNavCollapsed = useIsLeftNavCollapsed();
  const isForcedCollapsed = useIsLeftNavForcedCollapsedAtCurrentWidth();

  return isLeftNavCollapseEnabled && (isLeftNavCollapsed || isForcedCollapsed);
};
